// Autocomplete for the "Submit to Director" email field.
// Suggests emails from the users table but still allows any address to be typed
// (create: true). Value stays a comma-separated string, so the backend is unchanged.
$.onmount('[data-component=director-emails-select]', function () {
  var $el = $(this)
  var emails = $el.data('emails') || []

  var options = {
    plugins: ['remove_button'],
    delimiter: ',',
    persist: false,
    create: true,
    createOnBlur: true,
    options: emails.map(function (email) { return { value: email, text: email } }),
    placeholder: $el.attr('placeholder')
  }

  // The field lives inside a Bootstrap modal that is display:none on page load.
  // Selectize renders at 0 width if initialised while hidden, so defer to the
  // first time the modal is shown.
  var $modal = $el.closest('.modal')
  if ($modal.length) {
    $modal.one('shown.bs.modal', function () { $el.selectize(options) })
  } else {
    $el.selectize(options)
  }
})
